// Toggle visibilit of mobile menu on hamburger button click

const toggleMenuVisiblity = document.querySelector("[data-action='toggle-menu-visiblity']");

toggleMenuVisiblity.addEventListener("click", function () {
    let element = this;
    
    const html = document.querySelector("html");

    const active = element.closest(".active");
    if (window.innerWidth < 768) {
        if (active) {
            html.style.overflowY = 'auto';
        } else {
            html.style.overflowY = 'hidden';
        }
    }

    // Toggle class active for button
    element.classList.toggle("active");

    html.classList.toggle("show-menu");

    return false;
});


